import Modal from "../Modal/Modal";
import { ButtonConfigurate, Container } from "./ConfirmationModalStyles";

export const ConfirmationModalThird = (props) => {
  const { title, onAccept, toggleModal, zIndex, buttonTitle, backgroundColor } =
    props;

  return (
    <Modal
      zIndex={zIndex}
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{title}</h1>
        <div> {props.children}</div>
        <ButtonConfigurate
          onClick={() => {
            onAccept();
          }}
          backgroundColor={backgroundColor}
        >
          {buttonTitle}
        </ButtonConfigurate>
      </Container>
    </Modal>
  );
};
